@if (isMenu) {
  @if (showButton) {
    <button mat-menu-item [attr.aria-label]="'downloadSingleEml' | translate">
      <div class="item-menu-center">
        <span class="material-symbols-outlined">download_2</span>
        <span>{{ 'downloadSingleEml' | translate }}</span>
      </div>
    </button>
  }
} @else {
  <app-loading-icon-button
    label="downloadSingleEml"
    icon="download_2"
    classIcon="material-symbols-outlined"
    [showButton]="showButton"
    [showLoading]="showLoading">
  </app-loading-icon-button>
}
